import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/header.component';

// Layout for all app pages
const AppLayout = ({ pageTitle, children }) => {
  const appName = process.env.REACT_APP_NAME;

  return (
    <>
      <Helmet>
        <title>
          {appName} - {pageTitle}
        </title>
      </Helmet>

      <Header pageTitle={pageTitle} />

      {children}
    </>
  );
};

AppLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

export default AppLayout;
